import styled from "@emotion/styled";
import { Divider } from "@mui/material";

export const StyledDivider = styled(Divider, {
  shouldForwardProp: prop => prop !== "isReadOnly"
})`
  background-color: ${({ isReadOnly }) => isReadOnly ? "#ffffff" : "#ffffff66"};
  height: 22px;
`;
